import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const AgentStats = ({ stats, rating }) => {
  return (
    <section className='agent-stats'>
      <Fade bottom distance='40px'>
        <div className='agent-stats__inner'>
          <div className='agent-stats__stats'>
            { stats && stats.map((stat, index) => (
              <div className='agent-stats__stat' key={index}>
                <h4>{parse(stat.label)}</h4>
                <p>{stat.value}</p>
              </div>
            )) }
            { rating &&
              <div className='agent-stats__stat'>
                <h4>Average Client Rating</h4>
                <ul>
                  <li>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.0836 6.33358H9.70858L7.99998 0.916382L6.29138 6.33358H0.916382L5.49998 9.66638L3.41638 15.0836L7.99998 11.75L12.5836 15.0836L10.5 9.66638L15.0836 6.33358Z" fill="#3C3C3C"/>
                    </svg>
                  </li>
                  <li>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.0836 6.33358H9.70858L7.99998 0.916382L6.29138 6.33358H0.916382L5.49998 9.66638L3.41638 15.0836L7.99998 11.75L12.5836 15.0836L10.5 9.66638L15.0836 6.33358Z" fill="#3C3C3C"/>
                    </svg>
                  </li>
                  <li>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.0836 6.33358H9.70858L7.99998 0.916382L6.29138 6.33358H0.916382L5.49998 9.66638L3.41638 15.0836L7.99998 11.75L12.5836 15.0836L10.5 9.66638L15.0836 6.33358Z" fill="#3C3C3C"/>
                    </svg>
                  </li>
                  <li>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.0836 6.33358H9.70858L7.99998 0.916382L6.29138 6.33358H0.916382L5.49998 9.66638L3.41638 15.0836L7.99998 11.75L12.5836 15.0836L10.5 9.66638L15.0836 6.33358Z" fill="#3C3C3C"/>
                    </svg>
                  </li>
                  <li>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.0836 6.33358H9.70858L7.99998 0.916382L6.29138 6.33358H0.916382L5.49998 9.66638L3.41638 15.0836L7.99998 11.75L12.5836 15.0836L10.5 9.66638L15.0836 6.33358Z" fill="#3C3C3C"/>
                    </svg>
                  </li>
                  <li><span>via Domain</span></li>
                </ul>
              </div>
            }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default AgentStats
